__webpack_require__.p = "https://livingartstatuettes.com/main/latest/";